import { render } from "./investigation.vue?vue&type=template&id=3aaf4268"
import script from "./investigation.vue?vue&type=script&lang=js"
export * from "./investigation.vue?vue&type=script&lang=js"

import "./investigation.vue?vue&type=style&index=0&id=3aaf4268&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__